import styled from "@emotion/styled";
import { Box, Paper, TableContainer as TableContainerMaterialUi } from "@mui/material";

export const PageContainer = styled(Box)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

export const FiltrosContainer = styled(Paper)`
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 2rem;
    border-radius: 0;
    flex-wrap: wrap;
    gap: 1rem;

    .filtros-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.75rem;

        @media(max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    .input-filtro {
        width: 200px;

        @media(max-width: 768px) {
            width: 100%;
        }
    }

    .select-programa {
        width: 280px;

        @media(max-width: 768px) {
            width: 100%;
        }
    }
`

export const ButtonsContainer = styled(Box)`
    display: flex;
    align-items: center;
    gap: 0.5rem;

    @media(max-width: 600px) {
        width: 100%;
    }
`

export const TableContainer = styled(TableContainerMaterialUi)`
    width: 100%;
    min-height: 400px;
`

export const EmptyState = styled(Box)`
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Loading = styled(Box)`
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
`
